import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export default function FloatingCall() {
  return (
    <motion.a
      href={COMPANY.phoneHref}
      data-testid="floating-urgence-button"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-[55] flex items-center gap-2.5 rounded-full bg-terra py-3.5 pl-4 pr-5 text-sm font-semibold text-white shadow-[0_10px_30px_rgba(217,107,67,0.45)] md:hidden"
      aria-label="Appel d'urgence fuite"
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-40" />
        <Phone className="relative h-4 w-4" />
      </span>
      Urgence fuite
    </motion.a>
  );
}
